import Vue from 'vue';
import { api } from "../../services/Api.js";

export function add_news_emoticon({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
      // make api call
    return api
    .post(school,"add_news_emoticon.php",payload)
    .then( result =>{ 
      // noting to do
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: add_news_emoticon_reaction: "+error);
      return error;
    })

  }